export const compareIgnoreCase = (a: string, b: string) => a && b && a.toLowerCase() === b.toLowerCase()
